export default __webpack_public_path__ + "static/grundfos-bg-2454d8ac88e41058d6c7665b8a8ce3f2.png";